import { useEffect } from 'react'
import { Link } from 'react-router-dom'

const TERMLY_SCRIPT_ID = 'termly-jssdk'
const TERMLY_SCRIPT_SRC = 'https://app.termly.io/embed-policy.min.js'
const TERMLY_POLICY_ID = 'dc42281a-9d31-4ca6-9a2a-184deb080b71'

/**
 * Terms of service page rendered inside the React application shell.
 *
 * The policy body is sourced from Termly; the surrounding cards provide
 * Vault-specific context that complements the embedded document.
 *
 * @returns JSX.Element The terms page
 */
function TermsPage() {
  // Re-inject the Termly loader on every mount. The vendor snippet bails when
  // its script tag is already present, so on SPA back-navigation the embed
  // would otherwise stay blank.
  useEffect(() => {
    document.getElementById(TERMLY_SCRIPT_ID)?.remove()
    const script = document.createElement('script')
    script.id = TERMLY_SCRIPT_ID
    script.src = TERMLY_SCRIPT_SRC
    script.async = true
    document.body.appendChild(script)
    return () => {
      script.remove()
    }
  }, [])

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <p className="legal-kicker">Vault Financial</p>
        <h1>Terms of Service</h1>
        <p className="legal-subtitle">
          Terms governing Vault Financial&apos;s planning workflows and Plaid-linked institution access.
        </p>
      </div>

      <div
        className="legal-termly-embed"
        dangerouslySetInnerHTML={{
          __html: `<div name="termly-embed" data-id="${TERMLY_POLICY_ID}"></div>`,
        }}
      />

      <div className="legal-grid">
        <section className="legal-card">
          <h2>Support and deletion</h2>
          <p>
            You can request account deletion in-app from Account Settings. Deletions enter a 30-day
            grace window before permanent purge. Support remains available at{' '}
            <a href="mailto:support@vaultfinance.ai">support@vaultfinance.ai</a>.
          </p>
        </section>
      </div>

      <div className="legal-actions">
        <Link to="/" className="btn btn-primary">
          Return Home
        </Link>
        <Link to="/privacy" className="btn btn-secondary">
          Review Privacy Policy
        </Link>
      </div>
    </div>
  )
}

export default TermsPage
